// extracted by mini-css-extract-plugin
export default {"listHeader":"ListHeader_listHeader__PXRfo"};